import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RoleIcon from '../shared/RoleIcon';

const ListItem = ({
  text,
  itemId,
  selected,
  disabled,
  handleSelection,
  handleExpendTree,
  listid,
  children,
  position,
  activationKey,
  name,
}) => {
  const roles = name.split('_');
  const isRldRole = roles.includes('RLD');
  const isAccRole = roles.includes('ACC');
  const handleItemSelection = event => {
    event.preventDefault();
    const selectedElementId = event.currentTarget.id;
    let clearExisting = true;
    let shiftKey = false;
    if (event.ctrlKey) {
      clearExisting = false;
    }
    if (event.shiftKey) {
      shiftKey = true;
    }
    handleSelection(selectedElementId, clearExisting, shiftKey);
  };

  const renderChildren = () => {
    const renderChild = _.map(children, module => {
      const { moduleId, moduleName, permissions } = module;
      const moduleIconClass = `${moduleName.replaceAll(' ', '').toLowerCase()}_icon`;
      const permissionItems = _.map(permissions, permission => {
        const { id, name } = permission;
        return (
          <li key={`permission_${id}`} id={`permission_${id}`}>
            {name}
          </li>
        );
      });
      return (
        <div
          key={`module_${moduleId}`}
          id={`module_${moduleId}`}
          className="dropdown-menu-children-items"
        >
          <h4 className="dropdown-title">
            <span
              className={`accounts-role-feature--name ${moduleIconClass}`}
            >
              {moduleName}
            </span>
          </h4>
          <ul className="dropdown-items">{permissionItems}</ul>
        </div>
      );
    });

    return <div className="dropdown-menu-children">{renderChild}</div>;
  };

  const hasChild = !_.isEmpty(children);
  let toggleIcon = String.fromCharCode(9658);
  if (hasChild) {
    toggleIcon = String.fromCharCode(9660);
  }
  if (activationKey && (isRldRole || isAccRole)) {
    return (
      <li id={itemId} className="dropdown-menu-multi-select">
        <div disabled className="disabled-sel-roles dropdown-menu-item">
          <button className="expend-tree-button" type="button">
            <span className="icon">{toggleIcon}</span>
          </button>
          <a style={{ cursor: 'not-allowed' }}>
            <RoleIcon size="18px" fill="#b2bece" />{' '}
            <span className="menu-text">{text}</span>
          </a>
        </div>
      </li>
    );
  }
  return (
    <li
      onMouseDown={handleItemSelection}
      id={itemId}
      className={
        selected
          ? 'dropdown-menu-multi-select active'
          : 'dropdown-menu-multi-select'
      }
    >
      <div
        disabled={disabled}
        className={
          disabled
            ? 'disabled-sel-roles dropdown-menu-item'
            : 'dropdown-menu-item'
        }
      >
        <button
          className="expend-tree-button"
          type="button"
          onClick={e => handleExpendTree(e, listid, hasChild, position)}
        >
          <span className="icon">{toggleIcon}</span>
        </button>
        <a>
          <RoleIcon size="18px" fill="#b2bece" />{' '}
          <span className="menu-text">{text}</span>
        </a>
      </div>
      {hasChild && renderChildren()}
    </li>
  );
};

ListItem.propTypes = {
  handleSelection: PropTypes.func,
  text: PropTypes.string,
  itemId: PropTypes.number,
  selected: PropTypes.bool,
  listid: PropTypes.number,
  position: PropTypes.string,
  handleExpendTree: PropTypes.func,
  children: PropTypes.instanceOf(Array),
  activationKey: PropTypes.bool,
};

export default ListItem;
